
import React from 'react';
import type { Comment, User } from '../types';
import { useNavigation } from '../contexts/NavigationProvider';
import { formatTimestamp } from '../utils/formatTimestamp';

interface CommentCardProps {
    comment: Comment;
}

const CommentCard: React.FC<CommentCardProps> = ({ comment }) => {
    const { handleViewProfile } = useNavigation();

    // The author on a comment might be a partial user, need to handle this gracefully
    // But since the API sends a full user for handleViewProfile, we construct a dummy one
    // and cast it to satisfy the User interface requirements for the navigation handler.
    const handleAuthorClick = () => {
        const authorAsUser = {
            ...comment.author,
            name: comment.author.name || '',
            handle: comment.author.handle || '',
            avatarUrl: comment.author.avatarUrl || '',
            title: comment.author.title || '',
            city: comment.author.city || 'Global',
            email: '',
        } as User;
        handleViewProfile(authorAsUser);
    }
    
    return (
        <div className="flex items-start space-x-3 py-2">
            <img 
                src={comment.author.avatarUrl} 
                alt={comment.author.name} 
                className="h-10 w-10 rounded-full cursor-pointer border border-gray-700 hover:border-brand-orange transition-colors"
                onClick={handleAuthorClick}
            />
            <div className="flex-1 bg-gray-700/50 rounded-lg p-3 border border-gray-700/30">
                <div className="flex items-baseline space-x-2">
                    <p 
                        className="font-bold text-white hover:text-brand-orange cursor-pointer transition-colors"
                        onClick={handleAuthorClick}
                    >
                        {comment.author.name}
                    </p>
                    <p className="text-xs text-brand-muted font-mono">@{comment.author.handle}</p>
                    <p className="text-[10px] text-brand-muted uppercase tracking-wider font-bold">&middot; {formatTimestamp(comment.timestamp)}</p>
                </div>
                <p className="mt-1 text-gray-300 whitespace-pre-wrap leading-relaxed">{comment.text}</p>
            </div>
        </div>
    );
};

export default CommentCard;
